import SCP_FRAMES_REQUEST_PRIORITY_TYPES from '../mw/scpFramesRequestPriorityTypes';

enum CM_PRIORITY_LEVEL_TYPES {
    LOW_PRIORITY = 'BottomOfQueue',
    TopOfQueue = 'TopOfQueue',
}

export default CM_PRIORITY_LEVEL_TYPES;

const PRIORITY_MAPPING = {
    [CM_PRIORITY_LEVEL_TYPES.LOW_PRIORITY]: SCP_FRAMES_REQUEST_PRIORITY_TYPES.LOW_PRIORITY,
    [CM_PRIORITY_LEVEL_TYPES.TopOfQueue]: SCP_FRAMES_REQUEST_PRIORITY_TYPES.HIGH_PRIORITY,
};

export const getScpFrameRequestPriorityByCmPriorityLevel = (
    priorityLevel?: CM_PRIORITY_LEVEL_TYPES
): SCP_FRAMES_REQUEST_PRIORITY_TYPES => {
    return priorityLevel ? PRIORITY_MAPPING[priorityLevel] : SCP_FRAMES_REQUEST_PRIORITY_TYPES.LOW_PRIORITY;
};
